import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readTotal: emisor =>
    api
      .send({
        query: gql`
          query readTotal($emisor: ID!) {
            Production {
              readTotal(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Production.readTotal),

  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Production {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  sequence
                  order
                  status
                  startDate
                  endDate
                  expirationDate
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Production.readAllByEmisor),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Production {
              readById(_id: $_id) {
                _id
                sequence
                order
                status
                startDate
                endDate
                expirationDate
                location
                user {
                  _id
                }
                item {
                  _id
                  name
                  unit
                  quantity
                  unitCost
                  itemRefId
                }
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Production.readById),

  readBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readBySearchString($emisor: ID!, $searchString: String!) {
            Production {
              readBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id
                  sequence
                  order
                  status
                  startDate
                  endDate
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Production.readBySearchString),

  readByDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readByDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Production {
              readByDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  _id
                  sequence
                  order
                  status
                  startDate
                  endDate
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Production.readByDateRange),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: ProductionInput!) {
            Production {
              create(input: $input) {
                _id
                sequence
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Production.create)
}
